import React, { useContext, useEffect, useState } from 'react';
import { useImmerReducer } from 'use-immer';
import { Link as RouterLink } from 'react-router-dom';
import axiosConfig from '../../../utils/axiosConfig';
import Cookies from 'js-cookie';
import useStyles from './ForgotPasswordStyles';
import { Formik, Form, Field } from 'formik';
import { TextField } from 'formik-material-ui';

import Alert from '@material-ui/lab/Alert';
import Image from 'material-ui-image';

import {
    Box, Button, Checkbox, CssBaseline, CircularProgress,
    FormControlLabel, Grid, Link, Paper, MuiTextField, Typography
} from '@material-ui/core';

/* Context */
import { GlobalProvider, StateContext, DispatchContext } from '../../../context/Provider';

const ForgotPassword = (props) => {
    
    const classes = useStyles();
    const appState = useContext(StateContext);
    const appDispatch = useContext(DispatchContext);

    const { authState } = appState;
    const { authDispatch, globalDispatch } = appDispatch;

    const [user, setUser ] = useState({email: ''});
    const [isLoading, setIsLoading] = useState(false);
    const [successMsg, setSuccessMsg] = useState(null);
    const [errorMsg, setErrorMsg] = useState(null);

    async function emailPasswordResetLink(values, resetForm) {
        const res = await axiosConfig.post(`/emailPasswordResetLink`, {
            email: values.email,
        });

        if (res.data.status_code === 'ok') {
            setSuccessMsg(res.data.message);
            setErrorMsg(null);
        } else {
            setErrorMsg(res.data.message);
            setSuccessMsg(null);
        }

        setIsLoading(false);
    }

    useEffect(() => { globalDispatch({type: 'setShowTabs', value: false}); }, []);

    return (
        <Grid container component="main" className={classes.root}>
            <CssBaseline />
            <Grid item xs={false} sm={4} md={7} className={classes.image} />
            <Grid item xs={12} sm={8} md={5} component={Paper} elevation={6} square>
                <div className={classes.paper}>
                    
                    <Box mb={2}>
                        <Image
                            src="/images/ap_epi_logo-resized.png"
                            imageStyle={{
                                width: '',
                                height: '80px',
                                position: 'relative'
                            }}
                            style={{paddingTop: '0'}}
                        />
                    </Box>

                    { successMsg ?
                        <Alert variant="filled" severity="success" style={{width: '100%'}}>
                            { successMsg }
                        </Alert>
                        : ''
                    }

                    { errorMsg ?
                        <Alert variant="filled" severity="error" style={{width: '100%'}}>
                            { errorMsg }
                        </Alert>
                        : ''
                    }

                    <Formik
                        initialValues={user}
                        validate={(values) => {
                            const errors = {};

                            if (!values.email) {
                                errors.email = 'This field is required';
                            } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.email)) {
                                errors.email = 'Please enter a valid email address';
                            }

                            return errors;
                        }}
                        onSubmit={(values, {setSubmitting, resetForm}) => {
                            setSubmitting(false);
                            setIsLoading(true);
                            setSuccessMsg(null);
                            setErrorMsg(null);
                            emailPasswordResetLink(values, resetForm);
                        }}
                    >
                        {({submitForm, isSubmitting, touched, errors}) => (
                            <Form className={classes.form}>

                                <Field
                                    component={TextField}
                                    label="Email Address (required)"
                                    name="email"
                                    fullWidth
                                    variant="outlined"
                                    margin="normal"
                                    autoComplete="off"
                                />

                                <Typography variant="body1" color="textSecondary">
                                    Forgot your password? Just let us know your email address and we will email you a password reset link.
                                </Typography>

                                <Button 
                                    disabled={isSubmitting}
                                    fullWidth
                                    color="primary"
                                    variant="contained"
                                    disableElevation
                                    className={classes.submit}
                                    onClick={submitForm}
                                >
                                    { isLoading 
                                        ? (<CircularProgress size={24} className={classes.buttonProgress} />) 
                                        : 'EMAIL PASSWORD RESET LINK'
                                    }
                                </Button>

                                <Link
                                    component={RouterLink}
                                    variant="body2"
                                    underline="always"
                                    to="/login"
                                >
                                    Back to login page
                                </Link>
                            </Form>
                        )}
                    </Formik>

                    {/* { state.loginErrorMessage != '' ?
                        <Alert variant="filled" severity="error" style={{width: '100%'}}>
                            { state.loginErrorMessage }
                        </Alert>
                        : ''
                    } */}
                
                </div>  
            </Grid>
        </Grid>
    );
}

export default ForgotPassword;